<template>
  <div class="block-card">
    <div class="block-card__container block-card__container--reverse">
      <div class="block-card__content">
        <div class="block-card__content__container">
          <div class="block-card__content__icon" v-if="block.icon">
            <img :src="block.icon" />
          </div>
          <h3>{{ block.heading }}</h3>
          <div class="block-card__content__copy">
            <div v-html="block.body"></div>
          </div>
        </div>
      </div>
      <div class="block-card__media">
        <div class="block-card__media__container">
          <img
            v-if="image"
            ref="img"
            :src="image.src"
            :srcset="image.srcset"
            :alt="image.title"
          />
        </div>
      </div>
    </div>

    <div class="block-card__divider">
      <div class="block-card__divider__line"></div>
    </div>
  </div>
</template>

<script>
import { bind, unbind } from '@/utils/eventListener';

export default {
  name: 'BlockInnerCard',
  props: {
    block: [Array, Object]
  },
  computed: {
    image() {
      return this.block && this.block.media && this.block.media.images
        ? this.block.media.images[0]
        : null;
    }
  },

  mounted() {
    const { img } = this.$refs;

    if (img.complete) {
      this.$emit('loaded');
    } else {
      bind(img, 'load', this.handleLoad);
    }
  },

  beforeDestroy() {
    const { img } = this.$refs;
    unbind(img, 'load', this.handleLoad);
  },

  methods: {
    handleLoad() {
      this.$emit('loaded');
    }
  }
};
</script>
